export default __webpack_public_path__ + "static/lozenge-dropdown-anatomy-light-95279e60e0ff9b4acd3d4969e7ba46f3d30a07ede52a473ff24b9d7a0bf9d42d.png";